import VisitorTypesDataTable from "../../../components/dataTable/tables/visitor/type/VisitorTypesDataTable";

function VisitorTypesPageView() {
  return <VisitorTypesDataTable />;
}

export default VisitorTypesPageView;
